import { render, staticRenderFns } from "./CreateUserTargetForm.vue?vue&type=template&id=6e98b46d&"
import script from "./CreateUserTargetForm.vue?vue&type=script&lang=ts&"
export * from "./CreateUserTargetForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateUserTargetForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports